import { createApiClient } from 'api/apiClient';
import React, { useEffect, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import Tableau from './Tableau';

const Dashboard = () => {
  const accessToken = localStorage.getItem('access_token');
  const controller = useMemo(() => new AbortController(), []);
  const apiClient = createApiClient(accessToken!, controller);

  const options = {
    width: '1200px',
    height: '800px',
    onFirstInteractive: (e: any) => console.log('Viz loaded!', e),
  };

  const [token, setToken] = useState();

  const {
    isLoading: isTwilioToken,
    mutate: getTwilioToken,
    data: twilioTokenResp,
  } = useMutation('twilio-token', async () => apiClient.getDashBoardToken(), {
    onError: error => {
      console.log('error ', error);
    },
  });

  useEffect(() => {
    getTwilioToken();
  }, []);

  console.log('twilioTokenResp', twilioTokenResp);

  return (
    <div>
      {twilioTokenResp && (
        <Tableau
          url="https://prod-apnortheast-a.online.tableau.com/#/site/consinttableauvisualizations/views/RPMCardiovascularConsultantsPCBillingMetricsforClient/RPMBillingMetrics?:iid=4"
          options={options}
          token={twilioTokenResp}
        />
      )}
    </div>
  );
};

export default Dashboard;
